// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".specification-content[data-v-11c6896e] div{display:flex}.specification-content[data-v-11c6896e] dt{flex-shrink:0;width:5rem;margin-right:1.25rem;color:rgba(0, 0, 0, 0.6)}@media (min-width: 768px){.specification-content[data-v-11c6896e] dt{width:100px;margin-right:2rem}}.specification-content[data-v-11c6896e] dd{flex-grow:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
